import { jsx as _jsx } from "react/jsx-runtime";
import { Plug } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { ChannelsListPage } from './routes/list-page.js';
const { Provider: ChannelsModulePermsProvider, usePerms: useChannelsPerms } = createModulePerms({ canManage: false });
export { ChannelsModulePermsProvider };
function ChannelsPageRoute() {
    const { canManage } = useChannelsPerms();
    return _jsx(ChannelsListPage, { canManage: canManage });
}
export const channelsModule = {
    id: 'channels',
    label: 'Channels',
    icon: Plug,
    permission: 'channels.list',
    workspace: 'system',
    order: 30,
    description: 'Inbound and outbound channels connected to the support pipeline.',
    routes: [{ path: '/', component: ChannelsPageRoute }],
};
export { ChannelsListPage } from './routes/list-page.js';
export { setChannelsApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map